import React from 'react'
import './ComponentsCss/NewsItem.css';
// imgs 
import img1 from '../imgs/bigImgs/pic1.jpg';
import ProfileImgs from '../imgs/NewsListImgs/profile.png';
const NewsItem = ({ mainImgSrc, showDetails }) => {
    return (
        <div className="content-container">
            <div className="content-box">

                <div className="content-body">
                    <img src={"https://stepupkorea.kr/images/news-lists/main/" + mainImgSrc} style={{ width: "100%" }} />


                    {
                        showDetails ?
                            <div className='NewsItemFlexBoxRow'>
                                <div className='newsitem-profile-box'>
                                    <img className='profile-image ' src={ProfileImgs} />
                                </div>
                                <div className='NewsItemFlexBoxRCol'>
                                    <div className='newsitem-title'>
                                        이성윤 의원 공동고발
                                    </div>
                                    <div className='newsitem-name'>
                                        도태우 변호사
                                    </div>
                                    <div>
                                        🕒 36 일 남음 · 859% 달성함
                                    </div>

                                </div>

                            </div>
                            :
                            null
                    }



                </div>

            </div>
        </div>
    )
}

export default NewsItem